import { SentryUtil } from '@/modules/common/utils/sentry.util.ts';

const BASE = 1024;

const UNITS = [
  'common.file.unit.byte',
  'common.file.unit.kilobyte',
  'common.file.unit.megabyte',
  'common.file.unit.gigabyte',
  'common.file.unit.terabyte',
];

const ZERO = {
  value: 0,
  unit: UNITS[0],
};

const logBase = Math.log(BASE);

function getIndex(size: number) {
  return Math.min(Math.floor(Math.log(size) / logBase), UNITS.length - 1);
}

function getValue(size: number, index: number) {
  return size / Math.pow(BASE, index);
}

export function getFileSize(size: number) {
  if (!Number.isFinite(size) || size < 0) {
    SentryUtil.fallback(`Invalid file size: ${size}`);
    return ZERO;
  }

  if (size === 0) {
    return ZERO;
  }

  const index = getIndex(size);

  return {
    value: getValue(size, index),
    unit: UNITS[index],
  };
}
